import { useEffect } from 'react';
import { subscribeActivityLiveStream } from '../lib/activityLiveStream';

export const ACTIVITY_LIVE_WINDOW_EVENT = 'fcp:activity-live';

/**
 * App-level SSE subscriber (authenticated routes only).
 * Dispatches window event so any page can refetch without its own connection.
 */
export function useActivityLiveStream({ enabled = true } = {}) {
  useEffect(() => {
    if (!enabled) return undefined;

    const unsubscribe = subscribeActivityLiveStream({
      enabled: true,
      onEvent: (payload) => {
        window.dispatchEvent(
          new CustomEvent(ACTIVITY_LIVE_WINDOW_EVENT, { detail: payload })
        );
      },
    });

    return unsubscribe;
  }, [enabled]);
}
